import React from 'react';
import PropTypes from 'prop-types';

import './FooterSub.scss';

const FooterSub = props => (
  <div className="footer-sub">
    <div className="container-guttered">
      <nav className="footer-sub-links">
        <ul>
          {props.boringLinks.map(link => (
            <li key={link.url}>
              <a href={link.url}>{link.linkText}</a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  </div>
);

FooterSub.propTypes = {
  boringLinks: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default FooterSub;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Footer/FooterSub/FooterSub.js